import React,{useState} from "react";
import OldCmpCapital from "./OldCmpCapital";
import NewCmpCapital from "./NewCmpCapital";
import Option from "../Option";
import BackButton from "../../../../../components/common/backbutton/BackButton";


const CompanyCapitalIncrease = () => {

  const [turnOn, setTurnOn] = useState(true)  
  
  return (
    <div className="px-10 lg:!px-14">
        <p className="text-primary-red  font-Rakkas mt-7 text-center  font-semibold tracking-wide underline md:!text-3xl">
          Company Capital Increase
        </p>
          <Option setTurnOn={setTurnOn}/>
      
        <div className="flex justify-between font-Calistoga ">
          <p className="text-primary-blue  text-lg underline">
            1. Business Name & Other Details
          </p>
        </div>

     
     { turnOn ?
     <OldCmpCapital/>:
      <NewCmpCapital/>}
 


        
    </div>
  );
};

export default CompanyCapitalIncrease;
